@if (loading) {
  <div class="activity-example-usage__spinner">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
}

@if (shouldRender) {
  <mat-accordion
    class="activity-example-usage"
    [class.activity-example-usage--warning]="hasReachedLimit"
    [class.activity-example-usage--info]="!hasReachedLimit"
  >
    <mat-expansion-panel class="activity-example-usage__panel">
      <mat-expansion-panel-header class="activity-example-usage__header">
        <mat-panel-title class="activity-example-usage__panel-title">
          <mat-icon class="activity-example-usage__icon">{{ hasReachedLimit ? 'warning' : 'info' }}</mat-icon>
          <span class="activity-example-usage__title-group">
            <span class="activity-example-usage__title-text">
              {{
                (hasReachedLimit ? 'activity.example_usage.warning_title' : 'activity.example_usage.info_title') | translate
              }}
            </span>
          </span>
        </mat-panel-title>
        <mat-panel-description class="activity-example-usage__panel-description">
          <span class="activity-example-usage__count-chip">{{ count }}/{{ maxUsageCount }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="activity-example-usage__content">
        <div class="activity-example-usage__status-card">
          <p class="activity-example-usage__status-summary">
            {{ 'activity.example_usage.summary' | translate : { count } }}
          </p>
          <p class="activity-example-usage__status">
            @if (hasReachedLimit) {
              {{ 'activity.example_usage.limit_reached' | translate : { limit: maxUsageCount } }}
            } @else {
              {{ 'activity.example_usage.limit_available' | translate : { remaining, limit: maxUsageCount } }}
            }
          </p>
        </div>
        @if (items.length > 0) {
          <div class="activity-example-usage__section-label">
            {{ 'activity.example_usage.details_title' | translate }}
          </div>

          <div class="activity-example-usage__list">
            @for (item of items; track item.program_template_id) {
              <button
                type="button"
                class="activity-example-usage__list-item"
                (click)="goToProgramTemplate(item.program_template_id)"
              >
                <span class="activity-example-usage__template-name">{{ item.program_template_name }}</span>
                <span class="activity-example-usage__meta">
                  #{{ item.program_template_id }}
                  <mat-icon>arrow_forward</mat-icon>
                </span>
              </button>
            }
          </div>
        }
      </div>
    </mat-expansion-panel>
  </mat-accordion>
}
